"use client";

import { type ReactNode } from "react";

/**
 * Renders children only when NOT running in Electron.
 * Used to skip web-only providers (GTM, Amplitude, Fingerprint)
 * that add network overhead without benefit in the desktop app.
 */
export function WebOnlyProviders({ children }: { children: ReactNode }) {
  if (typeof window !== "undefined" && window.electronAPI !== undefined) {
    return null;
  }
  return <>{children}</>;
}
